export {
  withState as withGameItemState,
  withFavorite as withGameItemFavorite,
} from './GameItem.state';
